import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import './SplitPaymentTimeline.css';

/**
 * SplitPaymentTimeline — sleek horizontal 2-step indicator.
 *
 * Props:
 *   variant: "light" (default, for white/off-white cards)
 *          | "dark"  (glassmorphic — for dark/premium cards)
 *   compact: boolean — tighter spacing for constrained containers
 */
export const SplitPaymentTimeline = ({ variant = 'light', compact = false }) => {
  return (
    <div
      className={`spt-wrap spt-${variant} ${compact ? 'spt-compact' : ''}`}
      data-testid="split-payment-timeline"
      role="group"
      aria-label="Split payment: $750 today, $750 after first interview"
    >
      <div className="spt-row">
        <div className="spt-col spt-col-now" data-testid="spt-step-today">
          <span className="spt-tag spt-tag-now">
            <Check className="spt-tag-icon" aria-hidden="true" /> Today
          </span>
          <span className="spt-amt">$750</span>
        </div>

        <ArrowRight className="spt-arrow" aria-hidden="true" />

        <div className="spt-col spt-col-later" data-testid="spt-step-after">
          <span className="spt-tag spt-tag-later">After 1st Interview</span>
          <span className="spt-amt">$750</span>
        </div>
      </div>

      <p className="spt-footnote" data-testid="spt-footer">
        No risk. No time limit. We don't stop until you secure <strong>10 interviews</strong>.
      </p>
    </div>
  );
};

export default SplitPaymentTimeline;
